export const dispatchKeys = {
    all: ['dispatch'] as const,
    attentionCount: () => [...dispatchKeys.all, 'attention-count'] as const,
    availabilityBoard: () => [...dispatchKeys.all, 'availability-board'] as const,
    availabilityBoardWindow: (startDate: string, endDate: string) =>
        [...dispatchKeys.availabilityBoard(), startDate, endDate] as const,
    board: (startDate: string, endDate: string) =>
        [...dispatchKeys.all, 'board', startDate, endDate] as const,
    yards: () => [...dispatchKeys.all, 'yards'] as const,
    drivers: () => [...dispatchKeys.all, 'drivers'] as const,
    driversForDay: (date: string) => [...dispatchKeys.drivers(), date] as const,
    absences: () => [...dispatchKeys.all, 'absences'] as const,
    workerAbsences: (workerId: string) => [...dispatchKeys.absences(), workerId] as const,
    outOfService: () => [...dispatchKeys.all, 'out-of-service'] as const,
    publications: () => [...dispatchKeys.all, 'publications'] as const,
    publicationsForDay: (boardDate: string) => [...dispatchKeys.publications(), boardDate] as const,
    summaries: () => [...dispatchKeys.all, 'summaries'] as const,
    summariesForDay: (boardDate: string) => [...dispatchKeys.summaries(), boardDate] as const,
    driveTimes: (legKeys: string[]) => [...dispatchKeys.all, 'drive-times', ...legKeys] as const,
}
